<template>
    <div>
        <a-row :gutter="16">
            <a-col :span="7">
                <a-form-model ref="ruleForm" :model="form" :rules="rules">
                    <a-form-model-item label="客户信息备注" prop="tripremind_name">
                        <a-textarea v-model="form.tripremind_name" placeholder="请输入客户信息备注"
                            :auto-size="{ minRows: 5, maxRows: 10 }" />
                    </a-form-model-item>
                </a-form-model>
                <a-form-model>
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">保存信息</a-button>
                </a-form-model>
            </a-col>
            <a-col :span="17">
                <p>客户信息备注记录：</p>
                <ul>
                    <li v-for="v in dataList">
                        <a-spin tip="保存中..." :spinning="updateLoading">
                            <div style="color: #000;font-weight: 500;font-size: 18px;"
                                v-if="v.tripremind_id != updateForm.tripremind_id">{{
                                    v.tripremind_name }}</div>
                            <a-textarea v-else v-model="updateForm.tripremind_name" aut placeholder="请输入客户信息备注"
                                :auto-size="{ minRows: 2, maxRows: 4 }" />
                            <p>
                                <a-space>
                                    <span style="margin-right: 10px;">{{ v.create_time }}</span>
                                    <span class="btn" style="color: #1890FF" @click="updateHandle(v)"
                                        v-if="v.tripremind_id != updateForm.tripremind_id">修改</span>
                                    <span class="btn" @click="updateHandleOk"
                                        v-if="v.tripremind_id == updateForm.tripremind_id">确认修改</span>
                                    <span class="btn" @click="updateForm.tripremind_id = ''"
                                        v-if="v.tripremind_id == updateForm.tripremind_id">取消修改</span>
                                    <span class="btn" style="color: red;" v-if="v.tripremind_id != updateForm.tripremind_id"
                                        @click="deleteHandle(v.tripremind_id)">删除</span>
                                </a-space>
                            </p>
                        </a-spin>
                    </li>
                    <a-empty v-if="dataList.length == 0" />
                </ul>
                <a-pagination class="ml-20 mt-20 float-left" show-size-changer :current="page" :total="total"
                    :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
                    @change="pageCurrentChangeHandle" />
            </a-col>
        </a-row>
    </div>
</template>
<script>
import viewModule from "@/mixins/view-module";
export default {
    mixins: [viewModule],
    props: ['trip_id'],
    data() {
        return {
            confirmLoading: false,
            updateLoading: false,
            dataForm: { trip_id: this.trip_id },
            updateForm: {
                tripremind_name: "",
                tripremind_id: "",
            },
            mixinViewModuleOptions: {
                getDataListURL: "/admin/trip/pageTripRemind",
                deleteURL: "/admin/trip/deleteTripRemind",
            },
            form: {
                tripremind_name: "",
            },
            rules: {
                tripremind_name: [
                    { required: true, message: "请输入客户信息备注", trigger: "blur" }
                ]
            }
        }
    },
    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: '/admin/trip/createTripRemind',
                        method: 'post',
                        data: {
                            ...this.form,
                            ...this.dataForm
                        }
                    }).then(() => {
                        this.$message.success('添加成功');
                        this.form.tripremind_name = ""
                        this.query()
                    }).finally(() => {
                        this.confirmLoading = false;
                    })
                }
            });
        },
        updateHandle(v) {
            this.updateForm.tripremind_name = v.tripremind_name
            this.updateForm.tripremind_id = v.tripremind_id
        },
        updateHandleOk() {
            if (this.updateForm.tripremind_name === "") {
                return this.$message.error("内容不能为空")
            }
            this.updateLoading = true;
            this.$http({
                url: '/admin/trip/updateTripRemind',
                method: 'post',
                data: this.updateForm
            }).then(() => {
                this.$message.success('修改成功');
                this.updateForm.tripremind_id = ''
                this.query()
            }).finally(() => {
                this.updateLoading = false;
            })

        }
    }
}
</script>
<style scoped>
.btn {
    cursor: pointer;
}
</style>